export default __webpack_public_path__ + "static/media/image33.4e4bce89.jpg";